import ngLoadingBar from 'angular-loading-bar';

/* @ngdoc object
 * @name themeBase
 * @description
 *
 */
angular
    .module('festzelt-os.theme.base', [
        ngLoadingBar
    ])
    .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = false;
    }])
    .run([
        '$rootScope',
        '$state',
        '$stateParams',
        function ($rootScope, $state, $stateParams) {
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
        }]);

require('./controllers/error-controller');
require('./controllers/locale-controller');



// WEBPACK FOOTER //
// ./src/app/theme/base/base-module.js